// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e64c8b87","453":"c13f836a","667":"ec04264c","977":"255be954"}[chunkId] + ".chunk.js";
};